<template>
    <el-dialog
        class="add"
        :visible.sync="addVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="600px"
        title="新增会议室"
    >
        <div class="container">
            <el-form
                ref="addForm"
                :rules="rules"
                :model="addForm"
                label-width="110px"
            >
                <el-row>
                    <el-col :span="24">
                        <el-form-item
                            label="会议室名称"
                            size="small"
                            prop="name"
                        >
                            <el-input
                                clearable
                                placeholder="请输入会议室名称"
                                size="small"
                                v-model="addForm.name"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item
                            label="会议室说明"
                            size="small"
                            prop="desc"
                        >
                            <el-input
                                type="textarea"
                                clearable
                                placeholder="请输入会议室说明"
                                size="small"
                                v-model="addForm.desc"
                                :autosize="{ minRows: 4, maxRows: 6 }"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="save"
                >保存</el-button
            >
            <el-button size="small" @click="addVisible = false">关闭</el-button>
        </span>
    </el-dialog>
</template>

<script>
import * as oaApi from "@/http/oaApi.js";
export default {
    data() {
        return {
            addForm: {
                name: "",
                desc: ""
            },
            rules: {
                name: [
                    {
                        required: true,
                        message: "请输入会议室名称",
                        trigger: "blur"
                    }
                ],
                desc: [
                    {
                        required: false,
                        message: "请输入会议室说明",
                        trigger: "blur"
                    }
                ]
            }
        };
    },
    props: {
        addVisible: Boolean,
        tableItem: Object
    },
    watch: {
        addVisible: {
            handler(newValue) {
                if (newValue) {
                }
            }
        }
    },
    created() {},
    methods: {
        /**
         * 保存
         */
        save() {
            this.$refs["addForm"].validate(valid => {
                if (valid) {
                    oaApi.meetingRoom({ ...this.addForm }, "post").then(res => {
                        if (res) {
                            this.$parent.meetingRoom();
                            this.closeDialog();
                            this.$message.success("新增成功!");
                        }
                    });
                }
            });
        },
        /**
         * 关闭对话框
         */
        closeDialog() {
            this.$emit("update:addVisible", false);
            this.$refs["addForm"].resetFields();
            this.$refs["addForm"].clearValidate();
        }
    }
};
</script>

<style lang="scss" scoped>
.add {
    .el-dialog__body {
        padding: 20px 40px;
    }
    .el-select,
    .el-date-editor {
        width: 100%;
    }
    .el-form-item {
        .el-form-item__content {
            .el-radio {
                margin: 0;
                width: 100px;
            }
        }
    }
    .container {
        margin-top: 10px;
    }
}
</style>
